import React from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Upsell } from './components/Upsell';
import { MoreTestimonials } from './components/MoreTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-background text-white selection:bg-primary selection:text-black" data-id="element-0">
      <TopBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <StatsBar data-id="element-4" />
        <Testimonials data-id="element-5" />
        <PainPoints data-id="element-6" />
        <ProductOverview data-id="element-7" />
        <Bonuses data-id="element-8" />
        <Pricing data-id="element-9" />
        <Upsell data-id="element-10" />
        <MoreTestimonials data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <CostComparison data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
}